export function ChartFallback() {
  return (
    <div
      role="status"
      aria-label="loading chart"
      className="h-56 w-full animate-pulse rounded-md border border-slate-800 bg-slate-900/50"
    />
  );
}
